module.exports = __webpack_public_path__ + "static/media/11.edf64365.jpg";